import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from "../../../../../../common/utils/commonUrl";
import http from "../../../../../../common/utils/http";
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import Vue from 'vue';
import { Uploader } from 'vant';

Vue.use(Uploader);
export default {
  data () {
    return {
      form: {
        address: '',
        contactPhone: '',
        codeToFileIds: {
          categoryIcon: []
        } //图片  
      },
      dialogImageUrl: '',
      dialogVisible: false,
      actionUrl: UPLOAD_FILE, //上传图片
      assessImageList: [],//上传图片
      dialogImageUrl: '',//上传图片
      detailsForm: {
        companyName: '',
        address: '',
        reservationPhone: '',
        rescuePhone: '',
        codeToFileIds: {
          logo: []
        }, //图片          
      },
    }
  },
  methods: {
    submit () {
      console.log(this.form, 'this.fileList')
      const myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(14[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1}))+\d{8})$/
      if (this.form.address == '') {
        this.$message.warning('地址不可为空！')
        return
      };
      if (!this.form.contactPhone) {
        this.$message.warning('手机号不能为空！')
        return
      }
      if (!myreg.test(this.form.contactPhone)) {
        this.$message.warning('手机号格式不正确！')
        return
      }
      http.post(API_BASE_URL + '/api/wxoa/member/member/createRescueClue', this.form).then(
        res => {
          this.$message.success('一键救援成功!')
          setTimeout(this.$router.go(-1), 3000)
        }
      )
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`)
        .then(res => {
          this.form.contactPhone = res.data.data.phoneNumber;
        });
    },
    getCompanyInfo () {
      http.get(API_BASE_URL + '/api/sys/prop/typeId/100/propName/companyInfo').then(
        res => {
          const id = res.data.data.id
          const info = res.data.data.value
          const codeToFileIds = info.codeToFileIds || {}
          codeToFileIds.logo = codeToFileIds.logo || []
          this.id = id
          this.detailsForm = {
            companyName: info.companyName,
            address: info.address,
            reservationPhone: info.reservationPhone,
            rescuePhone: info.rescuePhone,
            codeToFileIds: codeToFileIds
          }

          if (codeToFileIds && codeToFileIds.logo) {
            this.assessImageList2 = []
            let fileIds = codeToFileIds.logo
            this.fileIdList = fileIds
            fileIds.forEach((item, index) => {
              this.assessImageList2.push({
                name: item,
                uid: index,
                url: `${DOWNLOAD_FILE}${item}`
              })
            })
          }
        }
      )
    },
    // 上传图片
    beforeUpload (file) {
      const imgTypes = ['jpg', 'png']
      const fileSplitList = file.name.split('.')
      const fileSuffix = fileSplitList[fileSplitList.length - 1]
      if (!imgTypes.includes(fileSuffix)) {
        this.$message.error('只能上传图片')
        return false
      } else {
        return true
      }

    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    successFile (response, file, fileList) {
      this.form.codeToFileIds.categoryIcon.push(response.data.fileId)
      console.log(this.form.codeToFileIds.categoryIcon)

    },
    handleRemove (file, fileList) {
      console.log(this.form.codeToFileIds.categoryIcon, 'sss')

      // 如果用户上传图片之后不想要了，删除图片，那么同时也要删除集合中已上传成功的文件
      const addFileIndex = this.form.codeToFileIds.categoryIcon.findIndex(item => item === file.response ? file.response.data.fileId : file.name)
      console.log(this.form.codeToFileIds.categoryIcon, addFileIndex)

      if (addFileIndex !== -1) {
        this.form.codeToFileIds.categoryIcon.splice(addFileIndex, 1)
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除该图片吗？`)
    },

  },
  mounted () {
    document.title = '一键救援'
    this.getMemberDetails()
    this.getCompanyInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/one-click-rescue/one-click-rescue.js